var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX37Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 73,
    viewBox: "0 0 239 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8799 3.04172V6.22126H0.0810547V3.04172L3.33574 0H63.6252L66.8799 3.04172Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8809 33.3201V39.5413H34.755L31.5003 36.5004L34.755 33.3201H66.8809Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19466 66.6401H66.8799V69.8204L63.6252 72.8621H0.0810547V69.8204L3.19466 66.6401Z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.288 11.1995L97.0263 73.0001H92.9221V68.1615L151.23 11.1995H160.288Z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.493 0V3.04172L165.237 6.22126H92.9191V3.17954L96.0327 0H168.493Z",
    fill: "#FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.62 41.7532L205.148 37.3288L184.911 17.6965H179.109V20.7383L200.62 41.7532Z",
    fill: "#FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.967 69.8206V73.0001H184.77L208.687 49.6348L232.605 73.0001H238.407V69.9584L213.216 45.2104L237.982 21.016V17.8364H232.18L178.967 69.8206Z",
    fill: "#FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX37Logo);
export default __webpack_public_path__ + "static/media/x37logo.b3dc217e97de83f210c61a01afe1d565.svg";
export { ForwardRef as ReactComponent };